import { render, staticRenderFns } from "./RecursosOperacao.vue?vue&type=template&id=70d17f0b&"
import script from "./RecursosOperacao.vue?vue&type=script&lang=js&"
export * from "./RecursosOperacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports